var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"justify-between h-screen flex flex-col lg:flex-row"},[_c('dashboard-warning-modal'),_c('div',{staticClass:"flex-grow overflow-auto"},[_c('div',{class:{'p-1': _vm.enablePadding}},[_vm._t("default")],2)]),_c('div',{staticClass:"w-full lg:w-72 flex-shrink-0 bg-gray-200"},[_vm._t("sidebar")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }